import { render } from "./SupplyChainDashboard.vue?vue&type=template&id=3bc34214"
import script from "./SupplyChainDashboard.vue?vue&type=script&lang=js"
export * from "./SupplyChainDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__